module.exports = __webpack_public_path__ + "img/grand-cancun-beach.a0c58d47.jpg";